// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2K36Q","footer":"ModalError_footer__1EM9J"};